import React, { useEffect, useRef, useState } from "react";
import LayoutBackOffice from "../../../components/LayoutBackOffice";
// import iconeboutique from "../../../assets/IconeSvg/classe.svg";
import iconeCloseWindow from "../../../assets/IconeSvg/close_window.svg";
import iconethreeDots from "../../../assets/IconeSvg/treeDotsGray.svg";
import iconeDelete from "../../../assets/IconeSvg/delete.svg";
import iconePencil from "../../../assets/IconeSvg/pencil.svg";
import iconeAppareilPhoto from "../../../assets/IconeSvg/appareil_photo.svg";

import iconeDownload from "../../../assets/IconeSvg/download-minimalistic.svg";
import {
  Drawer,
  FormControl,
  MenuItem,
  OutlinedInput,
  Pagination,
  Select,
  SwipeableDrawer
} from "@mui/material";
import { TailSpin, ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

import SnackbarAlert from "../../../components/SnackbarAlert";
import {
  enregistrerProduitsBackoffice,
  listeDesproduct2,
  modifierProduitsById,
  supprimerProduitById
} from "../../../services/produits/ProduitsRequest";

import { listeSpecificationSansFiltre } from "../../../services/parametrage/SpecificationRequest";
import { listesubCategoriesSansFiltre } from "../../../services/parametrage/SubCategorieRequest";
import { listeCategoriesSansFiltre } from "../../../services/parametrage/CategorieRequest";
import DatePicker from "react-datepicker";
import {
  listeBoutiqueSansFiltre,
  listeDesBoutiques
} from "../../../services/commandes/CommandesRequest";
import { jwtDecode } from "jwt-decode";
import { listeMarquesSansFiltre } from "../../../services/parametrage/MarqueRequest";

// import { ArrowDownToLine } from "lucide-react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

const ProduitsBackoffice = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 10,
    nombrePage: 1,
    pagePagination: 1
  });
  const [loadingData, setLoadingData] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingDataLocalisation, setLoadingDataLocalisation] = useState(false);

  const fileInputRef = useRef(null);
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);

  // État pour chaque unité
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [searchParam, setSearchParam] = useState("");
  const [arrayCategorie, setArrayCategorie] = useState([]);
  const [arraySpecification, setArraySpecification] = useState([]);
  const [arrayMarque, setArrayMarque] = useState([]);
  const [arraySubCategorie, setArraySubCategorie] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [ProduitList, setProduitList] = useState([]);

  const [ProduitInfo, setProduitInfo] = useState(null);
  const [connectedUser, setConnectedUser] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [ProduitData, setProduitData] = useState({
    name: "",
    description: "",
    stock: "",
    enSolde: false,
    enVedette: false,
    boutique: "",
    prix: 0,
    finSolde: new Date(),
    prixSolde: "",
    forfait: "",
    pourcentageSolde: 0,
    images: [],
    categorie: "",
    subCategorie: "",
    marque: "",
    specifications: [
      {
        spec: "",
        value: ""
      }
    ]
  });

  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center"
  });
  const { vertical, horizontal } = snackbarPosition;

  const addSpec = () => {
    setProduitData((prev) => ({
      ...prev,
      specifications: [...prev.specifications, { spec: "", value: "" }]
    }));
  };

  // Suppression d'une spécification à l'index idx
  const removeSpec = (idx) => {
    setProduitData((prev) => ({
      ...prev,
      specifications: prev.specifications.filter((_, i) => i !== idx)
    }));
  };

  // Mise à jour d'une spécification (champ 'spec' ou 'value')
  const handleSpecChange = (idx, field, newVal) => {
    setProduitData((prev) => ({
      ...prev,
      specifications: prev.specifications.map((item, i) =>
        i === idx ? { ...item, [field]: newVal } : item
      )
    }));
  };

  // Upload photo de profil
  const handleClick = () => {
    if (selectedFiles.length === 5) {
      setErrorMessage(
        "Désolé vous avez atteind le nombre d'image requis. Retirer pour en ajouter de"
      );
      setSnackbarOpenError(true);
      return;
    }

    fileInputRef.current.click();
  };

  const removeImage = (index) => {
    const newFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(newFiles);
    setFile(newFiles);

    // Cas où il reste au moins une image
    if (newFiles.length > 0) {
      const first = newFiles[0];

      if (first instanceof Blob) {
        // Si c’est un File/Blob, on en crée la preview en base64
        const reader = new FileReader();
        reader.onload = (e) => setPreview(e.target.result);
        reader.readAsDataURL(first);
      } else if (typeof first === "string") {
        // Si c’est une URL (string), on l’affecte directement
        setPreview(first);
      }
    } else {
      // Plus d’images → on reset la preview
      setPreview(null);
    }

    // Mettre à jour l’état global du produit
    setProduitData((prev) => ({
      ...prev,
      images: newFiles
    }));
  };


  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    const remainingSlots = 5 - selectedFiles.length;
    const newFiles = files.slice(0, remainingSlots);
    const updatedFiles = [...selectedFiles, ...newFiles].slice(0, 5);

    setSelectedFiles(updatedFiles);
    setFile(updatedFiles);
    setProduitData((prev) => ({ ...prev, images: updatedFiles }));

    // Preview de la première image ou URL
    const first = updatedFiles[0];
    if (first instanceof Blob) {
      // Seulement un Blob/File → lecture via FileReader
      const reader = new FileReader();
      reader.onload = (e) => setPreview(e.target.result);
      reader.readAsDataURL(first); // OK si Blob :contentReference[oaicite:5]{index=5}
    } else if (typeof first === "string") {
      // URL existante → attribution directe
      setPreview(first);
    }
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;
    setProduitData((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeSelected = (e) => {
    const { name, type, checked, value } = e.target;
    setProduitData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const ProduitElement = ({ element }) => {
    return (
      <tr className=" bg-white">
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          <img
            src={element.images[0] ? element.images[0] : "-"}
            alt=""
            className="w-10 h-10"
          />
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium w-60">
          <div className="w-40 truncate">
            {element.name ? element.name : "-"}
          </div>
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium w-90">
          <div className="w-60 truncate">
            {element.description ? element.description : "-"}
          </div>
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          {element.marque ? element.marque.nom : "-"}
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          {element.prix ? element.prix : "-"} FCFA
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          {element.stock ? element.stock : "-"}
        </td>
        <td className="px-4 truncate text-sm text-stone-500 font-medium">
          -{element.pourcentageSolde ? element.pourcentageSolde : "-"} %
        </td>

        <td className="px-4">
          <div className="dropdown dropdown-left dropdown-end">
            <div
              tabIndex={0}
              className="w-7 h-7 rounded-lg bg-gray-200 flex items-center justify-center cursor-pointer"
            >
              <img src={iconethreeDots} alt="" />
            </div>
            <ul
              tabIndex={0}
              className="dropdown-content z-50 menu p-1 shadow border bg-white rounded-lg w-32 mr-2"
            >
              <button
                onClick={() => {
                  setProduitInfo(element);
                  openModalModif(element);
                }}
                className="w-full h-9 px-2 hover:bg-zinc-100 flex gap-x-1 items-center justify-start rounded-md"
              >
                <img src={iconePencil} alt="" className="w-5" />
                <span className="font-semibold text-sm">Modifier</span>
              </button>

              <button
                onClick={() => {
                  setProduitInfo(element);
                  document.getElementById("delete_produit").showModal();
                }}
                className="w-full h-9 px-2 hover:bg-zinc-100 flex gap-x-1 items-center justify-start rounded-md"
              >
                <img src={iconeDelete} alt="" className="w-5" />
                <span className="font-semibold text-sm">Supprimer</span>
              </button>
            </ul>
          </div>
        </td>
      </tr>
    );
  };

  
  const openModalModif = (element) => {
    setOpenModal(true);
    setProduitInfo(element);
    console.log("modification-Actif :", element);
    // on récupère les données pour le formulaire
    setProduitData({
      name: element.name,
      description: element.description,
      stock: element.stock,
      enSolde: element.enSolde,
      enVedette: element.enVedette,
      prix: element.prix,
      finSolde: element.finSolde,
      prixSolde: element.prixSolde,
      pourcentageSolde: element.pourcentageSolde,
      images: element.images,
      categorie: element.categorie._id,
      // subCategorie: element.subCategorie._id, utiliser cela quand le client le demandera
      marque: element.marque._id,
      specifications: element.specifications
    });
    setSelectedFiles(element.images);
  };

  const getlisteDesproduct = () => {
    setLoadingData(true);
    listeDesproduct2(pageQuery.page, pageQuery.size, searchParam)
      .then((res) => {
        setLoadingData(false);
        setProduitList(res.data.products);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalProducts
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  };

  const enregistrementProduit = () => {
    setIsLoading(true);
    const data = new FormData();
    // 1) Champs simples
    data.append("name", ProduitData.name);
    data.append("description", ProduitData.description);
    data.append("prix", ProduitData.prix);
    data.append("stock", ProduitData.stock);
    data.append("enVedette", ProduitData.enVedette);
    data.append("enSolde", ProduitData.enSolde);
    // 2) Champs JSON
    data.append("specifications", JSON.stringify(ProduitData.specifications));
    data.append("categorie", ProduitData.categorie);
    data.append("marque", ProduitData.marque);
    // data.append("subCategorie", ProduitData.subCategorie);
    // 3) Fichiers images
    ProduitData.images.forEach((file) => {
      data.append("images", file);
    });
    // 4) Autres champs conditionnels
    if (ProduitData.enSolde) {
      new Date().getTime();
      data.append("finSolde", ProduitData.finSolde);
    }
    data.append("prixSolde", ProduitData.prixSolde);
    data.append("pourcentageSolde", ProduitData.pourcentageSolde);

    console.log("formData :", Array.from(data.entries()));
    enregistrerProduitsBackoffice(data)
      .then((res) => {
        setSuccessMessage("Produit créé avec succès");
        getlisteDesproduct();
        setSnackbarOpenSuccess(true);
        setProduitData({
          title: "",
          descriptionCourte: "",
          startDate: "",
          endDate: "",
          boutique: "",
          cout: "",
          categorie: [],
          typeProduit: "",
          forfait: "",
          discountPercentage: 0,
          images: null,
          referencePaiement: "",
          photoRecuPaiement: null,
          specifications: [
            {
              spec: "",
              value: ""
            }
          ]
        });
        setSelectedFiles([]);
        setPreview(null);
        setIsLoading(false);
        setOpenModal(false);
        setProduitData({});
      })
      .catch((err) => {
        setIsLoading(false);
        if (err) {
          setErrorMessage(err.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const modifProduit = async () => {
    setIsLoading(true);
    const data = new FormData();
    // 1) Champs simples
    data.append("name", ProduitData.name);
    data.append("description", ProduitData.description);
    data.append("prix", ProduitData.prix);
    data.append("stock", ProduitData.stock);
    data.append("enSolde", ProduitData.enSolde);
    data.append("enVedette", ProduitData.enVedette);
    // 2) Champs JSON
    data.append("specifications", JSON.stringify(ProduitData.specifications));
    data.append("categorie", ProduitData.categorie);
    data.append("marque", ProduitData.marque);
    // data.append("subCategorie", ProduitData.subCategorie);
    // 3) Fichiers images
    ProduitData.images.forEach((file) => {
      data.append("images", file);
    });
    // 4) Autres champs conditionnels
    if (ProduitData.enSolde) {
      data.append("finSolde", ProduitData.finSolde);
    }
    data.append("prixSolde", ProduitData.prixSolde);
    data.append("pourcentageSolde", ProduitData.pourcentageSolde);

    console.log("formData :", Array.from(data.entries()));

    modifierProduitsById(ProduitInfo._id, data)
      .then((res) => {
        setSuccessMessage("Produit créé avec succès");
        getlisteDesproduct();
        setSnackbarOpenSuccess(true);
        setProduitData({
          title: "",
          descriptionCourte: "",
            startDate: "",
            endDate: "",
            boutique: "",
            cout: "",
            categorie: [],
            typeProduit: "",
            forfait: "",
            discountPercentage: 0,
            images: null,
            referencePaiement: "",
            photoRecuPaiement: null,
            specifications: [
              {
                spec: "",
                value: ""
              }
            ]
          });
          setSelectedFiles([]);
        setPreview(null);
        setIsLoading(false);
        setOpenModal(false);
        setProduitData({});
      })
      .catch((err) => {
        setIsLoading(false);
        if (err && err.message) {
          setErrorMessage(err.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const supprimerboutique = () => {
    setDeleteLoading(true);

    supprimerProduitById(ProduitInfo._id)
      .then((res) => {
        setSuccessMessage("Produit supprimé avec succès");
        getlisteDesproduct();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("delete_produit").close();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err && err.response && err.response.data) {
          setErrorMessage(err.response.data.message);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  // === FILTRER LES ELEMENTS ===
  const filterElement = () => {
    setSearchLoading(true);
    listeDesproduct2(pageQuery.page, pageQuery.size, searchParam)
      .then((res) => {
        setSearchLoading(false);
        setProduitList(res.data.products);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalProduitsBackoffice
        }));
      })
      .catch((error) => {
        setSearchLoading(false);
        console.log("error", error);
      });
  };

  // === PAGINATION DES ELEMENTS ===
  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value
    }));

    listeDesproduct2(value, pageQuery.size, searchParam)
      .then((res) => {
        setLoadingData(false);
        setProduitList(res.data.products);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.totalProduitsBackoffice
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const getallCategories = () => {
    listeCategoriesSansFiltre()
      .then((res) => {
        console.log(res);
        setArrayCategorie(res.data.categories);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getallSubCategories = () => {
    listesubCategoriesSansFiltre()
      .then((res) => {
        console.log(res);
        setArraySubCategorie(res.data.subCategories);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getallMarque = () => {
    listeMarquesSansFiltre()
      .then((res) => {
        console.log(res);
        setArrayMarque(res.data.marques);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getallSpecification = () => {
    listeSpecificationSansFiltre()
      .then((res) => {
        console.log(res);
        setArraySpecification(res.data.specifications);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const token = localStorage.getItem("compte_admin");
    const decoded = token ? jwtDecode(token) : null;
    setConnectedUser(decoded);
  }, []);

  useEffect(() => {
    setLoadingData(true);
    listeDesproduct2(pageQuery.page, pageQuery.size, searchParam)
      .then((res) => {
        setLoadingData(false);
        setProduitList(res.data.products);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.totalPages,
          totalElements: res.data.allProduits
        }));
      })
      .catch((error) => {
        setLoadingData(false);
        console.log("error", error);
      });
  }, []);

  useEffect(() => {
    getallSpecification();
    getallCategories();
    getallMarque();
    getallSubCategories();
  }, []);

  return (
    <LayoutBackOffice>
      <div className="w-full p-4 ">
        <div className="w-full">
          <h1 className="text-xl md:text-3xl font-extrabold">
            ProduitsBackoffice
          </h1>
          <p className="mt-2 text-gray-500 font-medium text-sm sm:text-base md:text-lg">
            Listes des ProduitsBackoffice
          </p>
        </div>

        <div className="mt-5 w-full  h-auto justify-end flex xl:flex-row  lg:flex-row md:flex-row flex-col  gap-x-2 overflow-x-scroll sm:overflow-auto gap-y-2">
          <input
            type="text"
            placeholder="Rechercher un élement..."
            value={searchParam}
            onChange={(e) => setSearchParam(e.target.value)}
            className="input input-bordered w-full xl:w-56  lg:w-56 h-10 md:w-56 text-sm font-medium"
          />

          <button
            disabled={searchLoading}
            className="bg-gray-600 text-sm text-white h-10 w-full xl:w-fit  lg:w-fit  md:w-fit  px-4 font-semibold rounded-lg flex items-center justify-center"
            onClick={filterElement}
          >
            {!searchLoading ? (
              "Rechercher"
            ) : (
              <ThreeDots
                height="35"
                width="35"
                radius="9"
                color="#fff"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={searchLoading}
              />
            )}
          </button>
          {/* {connectedUser && connectedUser.role !== "boutique" && ( */}
          <button
            disabled={isLoading}
            className="bg-primary text-sm text-white h-10 w-full xl:w-fit  lg:w-fit  md:w-fit px-4 font-semibold rounded-lg flex items-center justify-center"
            onClick={() => {
              setProduitInfo(null);
              setOpenModal(true);
            }}
          >
            Ajouter une Produit
          </button>
          {/* )} */}
        </div>

        {/* Liste des ProduitsBackoffice   */}
        <div className="mt-2 w-full">
          <div className="overflow-x-auto w-full ">
            <table className="custom-table table table-zebra w-full">
              <thead>
                <tr className="bg-black h-12">
                  <th className="text-sm text-white">Image</th>
                  <th className="text-sm text-white">Désignation</th>
                  <th className="text-sm text-white">Description</th>
                  <th className="text-sm text-white">Marque</th>
                  <th className="text-sm text-white">Prix</th>
                  <th className="text-sm text-white">Stock</th>
                  <th className="text-sm text-white">Reduction</th>
                  <th className="text-sm text-white">Action</th>
                </tr>
              </thead>
              <tbody>
                {!loadingData && ProduitList.length > 0 ? (
                  ProduitList.map((item) => (
                    <ProduitElement key={item._id} element={item} />
                  ))
                ) : !loadingData && ProduitList.length === 0 ? (
                  <tr>
                    <td colSpan="8">
                      <div className="w-full h-32 bg-white flex gap-x-2 text-red-500 items-center justify-center">
                        <p className="font-semibold text-lg text-red-600">
                          Aucun produit trouvé
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && ProduitList.length === 0 ? (
                  <tr>
                    <td colSpan="8">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="30"
                          width="30"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="8">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="30"
                          width="30"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="flex justify-end mt-2">
            <Pagination
              count={pageQuery.nombrePage}
              page={pageQuery.pagePagination}
              variant="outlined"
              shape="rounded"
              onChange={handlePaginationChange}
            />
          </div>
        </div>
      </div>

      <Drawer
        anchor={"right"}
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setProduitInfo(null);
          setProduitData({
            title: "",
            descriptionCourte: "",
            startDate: "",
            endDate: "",
            boutique: "",
            cout: "",
            categorie: [],
            typeProduit: "",
            forfait: "",
            discountPercentage: 0,
            images: null,
            referencePaiement: "",
            photoRecuPaiement: null,
            specifications: [
              {
                spec: "",
                value: ""
              }
            ]
          });
          setSelectedFiles([]);
        }}
        className="update-catechumene"
      >
        <div className=" xl:w-[550px]  lg:w-[550px]  w-[375px] px-3 pt-2 bg-white">
          <div className="flex justify-start ">
            <img
              onClick={() => {
                setOpenModal(false);
                setProduitInfo(null);
                setProduitData({
                  title: "",
                  descriptionCourte: "",
                  startDate: "",
                  endDate: "",
                  boutique: "",
                  cout: "",
                  categorie: [],
                  typeProduit: "",
                  forfait: "",
                  discountPercentage: 0,
                  images: null,
                  referencePaiement: "",
                  photoRecuPaiement: null,
                  specifications: [
                    {
                      spec: "",
                      value: ""
                    }
                  ]
                });
                setSelectedFiles([]);
              }}
              src={iconeCloseWindow}
              className="cursor-pointer"
              alt=""
            />
          </div>

          <h2 className="my-3 text-lg font-bold">
            {ProduitInfo !== null
              ? "Modifier un produit"
              : "Enregistrer un produit"}
          </h2>

          <div className="flex flex-col justify-center items-center  mt-6">
            {/* Liste des vignettes */}
            {selectedFiles && selectedFiles.length > 0 ? (
              <>
                <button
                  onClick={handleClick}
                  className="flex justify-center items-center  py-1 px-4  bg-[#f3f3f3] rounded-lg cursor-pointer"
                >
                  <img src={iconeAppareilPhoto} className="w-8" alt="" />
                  <span className="text-[12px] font-medium">
                    Ajouter d'autres photos
                  </span>
                </button>
                <div className="w-full mt-4 space-y-2">
                  {selectedFiles?.map((file, index) => (
                    <div
                      key={index}
                      className="relative flex items-center justify-between border-[2px] rounded-lg px-4 py-1"
                    >
                      {/* <img
                        src={
                          ProduitInfo !== null
                            ? file
                            : URL.createObjectURL(file)
                        }
                        alt={`Preview ${index + 1}`}
                        className="h-12 w-12 object-cover"
                      /> */}
                      <img
                        src={
                          file instanceof Blob
                            ? URL.createObjectURL(file)
                            : file // pour les chaînes d’URL existantes
                        }
                        alt={`Preview ${index + 1}`}
                        className="h-12 w-12 object-cover"
                      />
                      <button
                        type="button"
                        onClick={() => removeImage(index)}
                        className=" text-red-500 font-semibold cursor-pointer bg-red-100 py-1 px-2 rounded-lg hover:text-red-700"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <>
                <div
                  onClick={handleClick}
                  className="flex justify-center items-center w-full h-40 bg-[#f3f3f3] rounded-md cursor-pointer"
                >
                  <div className="w-full h-64  flex flex-col justify-center items-center">
                    <img src={iconeAppareilPhoto} className="w-8" alt="" />
                    <span className="text-[12px] mt-4 font-medium">
                      Sélectionner vos images produit
                    </span>
                  </div>
                </div>
                <h2 className="text-[12px] italic font-semibold text-red-600 mt-2">
                  Maximum 5 images autorisées
                </h2>
              </>
            )}

            <input
              type="file"
              multiple
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
              accept="image/*"
            />
          </div>

          <div className="mt-6 space-y-1">
            <h2 className="text-[14px] font-semibold text-primary">
              Informations Produit
            </h2>
            <hr className="h-[2.5px] w-full" />
          </div>

          <div className="px-3 pb-10 w-full">
            <div className="flex flex-row w-full justify-center  gap-2">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-semibold text-md">
                    Titre du Produit <span className="text-red-600">*</span>
                  </span>
                </div>
                <input
                  type="text"
                  name="name"
                  value={ProduitData.name}
                  onChange={handleChange}
                  placeholder="STARTECH Mixeur Blender..."
                  className="input input-bordered bg-[#F9F9F9]"
                />
              </label>
            </div>
            <div className="flex justify-center items-center gap-x-3">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-semibold text-md">
                    Description <span className="text-red-600">*</span>
                  </span>
                </div>
                <textarea
                  name="description"
                  value={ProduitData.description}
                  onChange={handleChange}
                  placeholder="Entrez une description courte"
                  rows={3}
                  className="textarea bg-[#F9F9F9] border-[2px]"
                ></textarea>
              </label>
            </div>

            <div className="flex xl:flex-row lg:flex-row flex-col w-full justify-center gap-2">
              <label className="form-control  w-[50%]">
                <div className="label">
                  <span className="label-text font-semibold text-sm">
                    Catégorie <span className="text-red-600">*</span>
                  </span>
                </div>
                <select
                  name="categorie"
                  value={ProduitData.categorie}
                  onChange={handleChange}
                  className="select select-bordered bg-[#F9F9F9]"
                >
                  <option selected>Choisir une boutique</option>

                  {arrayCategorie &&
                    arrayCategorie.map((typeItem) => (
                      <option
                        className="bg-[#F9F9F9] text-black"
                        key={typeItem._id}
                        value={typeItem._id}
                      >
                        {typeItem.nom}
                      </option>
                    ))}
                </select>
              </label>
              <label className="form-control w-[50%]">
                <div className="label">
                  <span className="label-text font-semibold text-sm">
                    Sélectionner une marque{" "}
                    <span className="text-red-600">*</span>
                  </span>
                </div>
                <select
                  name="marque"
                  value={ProduitData.marque}
                  onChange={handleChange}
                  className="select select-bordered bg-[#F9F9F9]"
                >
                  <option selected>Choisir une marque</option>

                  {arrayMarque &&
                    arrayMarque.map((typeItem) => (
                      <option
                        className="bg-[#F9F9F9] text-black"
                        key={typeItem._id}
                        value={typeItem._id}
                      >
                        {typeItem.nom}
                      </option>
                    ))}
                </select>
              </label>
              {/* <label className="form-control  w-[50%]">
                <div className="label">
                  <span className="label-text font-semibold text-sm">
                    Sous-catégorie <span className="text-red-600">*</span>
                  </span>
                </div>
                <select
                  name="subCategorie"
                  value={ProduitData.subCategorie}
                  onChange={handleChange}
                  className="select select-bordered bg-[#F9F9F9]"
                >
                  <option selected>Choisir une sous-catégorie</option>

                  {arraySubCategorie &&
                    arraySubCategorie.map((typeItem) => (
                      <option
                        className="bg-[#F9F9F9] text-black"
                        key={typeItem._id}
                        value={typeItem._id}
                      >
                        {typeItem.name}
                      </option>
                    ))}
                </select>
              </label> */}
            </div>

            {/* <label className="form-control w-[100%]">
              <div className="label">
                <span className="label-text font-semibold text-sm">
                  Sélectionner une marque{" "}
                  <span className="text-red-600">*</span>
                </span>
              </div>
              <select
                name="marque"
                value={ProduitData.marque}
                onChange={handleChange}
                className="select select-bordered bg-[#F9F9F9]"
              >
                <option selected>Choisir une marque</option>

                {arrayMarque &&
                  arrayMarque.map((typeItem) => (
                    <option
                      className="bg-[#F9F9F9] text-black"
                      key={typeItem._id}
                      value={typeItem._id}
                    >
                      {typeItem.nom}
                    </option>
                  ))}
              </select>
            </label> */}

            <div className="flex justify-center items-center gap-x-3">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-semibold text-md">
                    Prix <span className="text-red-600">*</span>
                  </span>
                </div>

                <input
                  type="text"
                  name="prix"
                  value={ProduitData.prix}
                  onChange={handleChange}
                  placeholder="5000"
                  className="input input-bordered w-full bg-[#F9F9F9]"
                />
              </label>

              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-semibold text-md">
                    Stock <span className="text-red-600">*</span>
                  </span>
                </div>
                <input
                  type="text"
                  name="stock"
                  value={ProduitData.stock}
                  onChange={handleChange}
                  placeholder="30"
                  className="input input-bordered w-full bg-[#F9F9F9]"
                />
              </label>
            </div>
            <div className="flex justify-center items-center gap-x-3">
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-semibold text-md">
                   Réduction de (FCFA) <span className="text-red-600">*</span>
                  </span>
                </div>
                <input
                  type="text"
                  name="prixSolde"
                  value={ProduitData.prixSolde}
                  onChange={handleChange}
                  placeholder="Prix promotionnel"
                  className="input input-bordered w-full bg-[#F9F9F9]"
                />
              </label>
              <label className="form-control w-full">
                <div className="label">
                  <span className="label-text font-semibold text-md">
                    Reduction en % <span className="text-red-600">*</span>
                  </span>
                </div>
                <input
                  type="text"
                  name="pourcentageSolde"
                  disabled
                  placeholder={
                    ProduitData.prix && ProduitData.prixSolde
                      ? Math.round(
                          (ProduitData.prixSolde * 100) / ProduitData.prix
                        )
                      : 0
                  }
                  value={
                    (ProduitData.pourcentageSolde = Math.round(
                      (ProduitData.prixSolde * 100) / ProduitData.prix
                    ))
                  }
                  onChange={handleChange}
                  className="input input-bordered w-full bg-[#F9F9F9]"
                />
              </label>
            </div>
            <div className="flex flex-row justify-start items-center gap-2 w-full">
              <label className="form-control w-fit flex flex-row gap-2 pt-4 items-center justify-start">
                <div className="label">
                  <span className="label-text font-semibold text-md">
                    Est-il un produit vedette ?{" "}
                    <span className="text-red-600">*</span>
                  </span>
                </div>
                <input
                  type="checkbox"
                  name="enVedette"
                  checked={ProduitData.enVedette === true}
                  value={ProduitData.enVedette}
                  onChange={handleChangeSelected}
                  className="toggle"
                />
              </label>

              <label className="form-control w-fit flex flex-row gap-2 pt-4 items-center justify-start">
                <div className="label">
                  <span className="label-text font-semibold text-md">
                    Est-il en promo flash ?{" "}
                    <span className="text-red-600">*</span>
                  </span>
                </div>
                <input
                  type="checkbox"
                  name="enSolde"
                  checked={ProduitData.enSolde === true}
                  value={ProduitData.enSolde}
                  onChange={handleChangeSelected}
                  className="toggle"
                />
              </label>
            </div>

            {ProduitData.enSolde ? (
              <>
                <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col gap-y-1 justify-center items-center gap-x-3">
                  <label className="form-control w-full">
                    <div className="label">
                      <span className="label-text font-semibold text-md">
                        Date fin promo flash{" "}
                        <span className="text-red-600">*</span>
                      </span>
                    </div>
                    <DatePicker
                      selected={ProduitData.finSolde}
                      showIcon
                      timeInputLabel="Time:"
                      dateFormat="  MM/dd/yyyy h:mm:ss aa"
                      showTimeInput
                      className="border-2 w-[100%] rounded-lg py-2 bg-[#F9F9F9] pl-4"
                      onChange={(date) => {
                        setProduitData((prev) => {
                          return { ...prev, finSolde: date };
                        });
                      }}
                    />
                  </label>
                </div>
              </>
            ) : null}

            {/* Spécifications dynamiques */}
            <fieldset className="border p-2 rounded">
              <legend className="font-semibold">
                Spécifications technique du produit
              </legend>

              {ProduitData?.specifications?.map((item, idx) => (
                <div key={idx} className="flex flex-row mb-2 gap-2 w-full">
                  <select
                    value={item.spec}
                    onChange={(e) =>
                      handleSpecChange(idx, "spec", e.target.value)
                    }
                    className="input input-bordered flex py-2 w-[40%]"
                  >
                    <option value="">-- Spécification --</option>

                    {arraySpecification &&
                      arraySpecification.map((typeItem) => (
                        <option
                          className="bg-[#F9F9F9] text-black"
                          key={typeItem._id}
                          value={typeItem._id}
                        >
                          {typeItem.name}
                        </option>
                      ))}
                  </select>
                  <div className="w-[80%] flex flex-row items-center justify-start">
                    <input
                      type="text"
                      value={item.value}
                      onChange={(e) =>
                        handleSpecChange(idx, "value", e.target.value)
                      }
                      placeholder="Valeur"
                      className="textarea border border-gray-200 w-full"
                    />
                    <button
                      type="button"
                      onClick={() => removeSpec(idx)}
                      className="text-red-600 px-2"
                    >
                      ×
                    </button>
                  </div>
                </div>
              ))}

              <button type="button" onClick={addSpec} className="text-blue-600">
                + Ajouter une autre spécification
              </button>
            </fieldset>

            <button
              // onClick={modifCatechu}
              onClick={
                ProduitInfo !== null ? modifProduit : enregistrementProduit
              }
              className="mt-5 bg-primary flex items-center justify-center w-full h-10 font-medium text-white rounded-lg hover:drop-shadow-md"
            >
              {!isLoading ? (
                <span>
                  {ProduitInfo !== null
                    ? "Modifier Produit"
                    : "Enregistrer Produit "}
                </span>
              ) : (
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={isLoading}
                />
              )}
            </button>
          </div>
        </div>
      </Drawer>

      {/* MODAL DELETE Produit */}
      <dialog id="delete_produit" className="modal">
        <div className="modal-box rounded-lg">
          <form method="dialog">
            <button className="w-7 h-7 absolute right-2 top-2">
              <img
                onClick={() => setOpenModal(false)}
                src={iconeCloseWindow}
                className="cursor-pointer w-full"
                alt=""
              />
            </button>
          </form>
          <h3 className="font-extrabold text-xl text-center text-primary">
            Supprimer cette Produit
          </h3>
          <div className="py-4">
            <p className="text-center text-base font-medium text-gray-600">
              Attention action est irrversible et entrainera la suppression de
              ce produit.
            </p>
          </div>
          <div className="modal-action flex justify-center">
            <form
              method="dialog"
              className="w-full flex flex-col sm:flex-row justify-center gap-x-3"
            >
              {/* if there is a button in form, it will close the modal */}
              {deleteLoading ? (
                <div
                  disabled={deleteLoading}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </div>
              ) : (
                <button
                  disabled={deleteLoading}
                  className="w-full sm:w-32 h-10 bg-gray-300 text-gray-700 text-sm rounded-lg flex items-center justify-center font-semibold"
                >
                  Annuler
                </button>
              )}
              <div
                onClick={supprimerboutique}
                disabled={deleteLoading}
                className="mt-2 sm:mt-0 w-full sm:w-56 px-2 h-10 bg-primary text-white text-sm rounded-lg flex items-center justify-center font-semibold cursor-pointer"
              >
                {!deleteLoading ? (
                  "Supprimer quand même"
                ) : (
                  <ThreeDots
                    height="40"
                    width="40"
                    radius="9"
                    color="#fff"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={deleteLoading}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </dialog>

      <SnackbarAlert
        vertical={vertical}
        horizontal={horizontal}
        snackbarSuccessOpen={snackbarSuccessOpen}
        handleCloseSnackbarSuccess={handleCloseSnackbarSuccess}
        successMessage={successMessage}
        snackbarErrorOpen={snackbarErrorOpen}
        handleCloseSnackbarError={handleCloseSnackbarError}
        errorMessage={errorMessage}
      />
    </LayoutBackOffice>
  );
};

export default ProduitsBackoffice;
